import AccountApi from '@/api/account'

// APIリクエスト用にformを整形するやつ
class AdvForm {
  constructor({ id, name, permission, belong }) {
    this.id = id
    this.name = name
    this.belong = belong
    this.permission = permission
    this.insertionOrders = []
  }
}

class IoForm {
  constructor({ id, name, permission }) {
    this.id = id
    this.name = name
    this.permission = permission
  }
}

class RequestBuilder {
  //
  static build(authChainModel, advIsInherit) {
    // 代理店が inherit であり、一度もいじられていない場合は inheritになおしてから送る
    if (advIsInherit === true && authChainModel.isChanged === false) {
      authChainModel.permission = 'inherit'
    }
    const advForm = new AdvForm(authChainModel)
    if (authChainModel.insertionOrderAuths !== undefined) {
      authChainModel.insertionOrderAuths.forEach((io, index, ios) => {
        const ioForm = new IoForm(io)
        advForm.insertionOrders.push(ioForm)
      })
    }
    return advForm
  }
}

const actions = {
  async GET({ commit }, { advertiserId, accountId, userType }) {
    // userTypeを保持
    commit('SET_CURRENT_EDITING_USER_TYPE', { userType })
    const data = await AccountApi.getAdvertiserAccountAuth(
      advertiserId,
      accountId,
    )
    const rawAuthChain = data.item
    // 一旦べた書き
    // const rawAuthChain = {
    //   id: 1,
    //   name: 'Advertiser 1',
    //   belong: true,
    //   permission: 'view',
    //   insertionOrders: [
    //     {
    //       id: 1,
    //       name: 'IO 1',
    //       permission: 'operator'
    //     },
    //     {
    //       id: 2,
    //       name: 'IO 2',
    //       permission: 'inherit'
    //     },
    //     {
    //       id: 3,
    //       name: 'IO 3',
    //       permission: 'inherit'
    //     }
    //   ]
    // }
    if (rawAuthChain.permission === 'inherit') {
      const isInherit = true
      commit('SET_ADVERTISER_INHERIT', { isInherit })
    }
    commit('INITIALIZE', { rawAuthChain, userType })
  },
  ON_PARENT_PERMISSION_CHANGE({ commit }, { permission }) {
    commit('SET_PARENT_PERMISSION', { permission })
  },
  ON_CHILD_PERMISSION_CHANGE({ commit }, { id, permission }) {
    commit('SET_CHILD_PERMISSION', { id, permission })
  },
  RESET({ commit }) {
    commit('RESET')
  },
  RESET_INHERIT_FLG({ commit }) {
    commit('RESET_INHERIT_FLG')
  },
  // 広告主権限の登録
  async SAVE_AUTH_CHAIN({ commit, state }, { advertiserId, accountId }) {
    const authChainModel = { ...state.currentAuthChain }
    // 代理店が初めにinheritかどうかでrequestの作り方が変わるので、渡す
    const inheritFlg = state.isInheritAdvertiser
    const requestBody = RequestBuilder.build(authChainModel, inheritFlg)
    const ret = await AccountApi.postAdvertiserAccountAuth(
      advertiserId,
      accountId,
      requestBody,
    )
    const rawAuthChain = ret.item
    const userType = state.currentEditingUserType
    commit('INITIALIZE', { rawAuthChain, userType })
  },
}

export default actions
